
import {
  defineComponent, onMounted, ref, Ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import AppAlert from '@/components/UI/AppAlert.vue';
import ValidationService from '@/services/ValidationService';
import { PASSWORD_LENGTH } from '@/types/consts';
import Terms from '@/modules/registration/components/Terms.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
// eslint-disable-next-line import/no-cycle
import RegistrationService from '@/modules/registration/services/RegistrationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
defineRule(
  'min6',
  (value: string) => (ValidationService.isLonger(value, PASSWORD_LENGTH))
    || 'Password is not valid, should be not less then 6 characters',
);
defineRule('capital', (value: string) => ValidationService.containsCapitalLetter(value) || 'Password is not valid, should contain: 1 uppercase letter');
defineRule('special', (value: string) => ValidationService.containsSpecialCharacter(value) || 'Password is not valid, should contain: 1 special character');
defineRule('numeric', (value: string) => ValidationService.containsNumeric(value) || 'Password is not valid, should contain: 1 number');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
    AppAlert,
    Terms,
    AppLoader,
  },
  setup() {
    const registrationStore = useRegistrationStore();
    const createInProgress = ref(false);

    const errorKey: Ref<string> = ref('');
    const passwordValue: Ref<string> = ref('');

    const router = useRouter();
    const schema = {
      password: 'required|min6|special|capital|numeric',
    };

    function nextStep() {
      createInProgress.value = true;
      registrationStore.credentials.password = passwordValue.value;

      RegistrationService.register(registrationStore.credentials).then((response) => {
        if (response.success) {
          router.push('/').then(() => {
            createInProgress.value = false;
          });
        } else {
          errorKey.value = response.errorKey === 'REGISTRATION_EMAIL_ALREADY_EXISTS'
            ? 'Account with this email already exists'
            : 'Your account information was entered incorrectly.';

          createInProgress.value = false;
        }
      }).catch(() => { createInProgress.value = false; });
    }

    onMounted(() => {
      if (!registrationStore.credentials?.email) {
        router.push('step-1');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      errorKey,
      schema,
      passwordValue,
      createInProgress,
      nextStep,
    };
  },
});
